import React, { useEffect, useRef, useState } from 'react';
import { IcoCalendar } from 'icons/indexed-icons/IcoCalendar';
//import { DateRangeProps } from '..';
import { format } from 'date-fns';
//import { DateRangeButtonProps } from '../DateRange/DateRangeButton/DateRangeButton.types';
//import { DateRangeButtonContainer } from '../DateRangeV1/DateRangeButton/DateRangeButton.elements';
import { utcToZonedTime } from 'date-fns-tz';
//import { getTzOffset } from '../DateRange/hooks/useDateRangeV2';
import { getCurrentZonedTime } from 'common/helpers/dateAndTimeHelpersV2';
import { DateRangeProps } from 'components/StyledUi/DateRange';
import { DateRangeButtonProps } from 'components/StyledUi/DateRange/DateRangeButton/DateRangeButton.types';
import { getTzOffset } from 'components/StyledUi/DateRange/hooks/useDateRangeV2';
import { DateRangeButtonContainer } from 'components/StyledUi/DateRange/DateRangeButton/DateRangeButton.elements';

const TIMER_INTERVAL = 1000;

interface FormatDateRangeProps extends DateRangeProps {
  dateFormat?: string;
  isUSTimeZone?: boolean;
  timeZone?: string;
}

type IntervalID = ReturnType<typeof setInterval>;

const formatDateRange = ({
  startTime,
  endTime,
  dateFormat,
  isUSTimeZone
}: FormatDateRangeProps) => {
  let displayFormat = 'MM/dd/yyyy HH:mm';
  if (isUSTimeZone) displayFormat = 'MM/dd/yyyy h:mm a';
  if (dateFormat === 'date-only') displayFormat = 'MM/dd/yyyy';

  return [format(startTime, displayFormat), format(endTime, displayFormat)];
};


export const DisplayDateRangeButton = ({
  dateFormat,
  dateRange,
  handleClick,
  iconOnly,
  className,
  ga,
  align,
  isUSTimeZone,
  timeZone
}: DateRangeButtonProps): JSX.Element => {

  className = className ? `ui-display-date-range-btn ${className}` : `ui-display-date-range-btn`;

  const timezone = timeZone || 'UTC';
  const offsetString = getTzOffset(timezone);
  const offsetStringUser = getTzOffset(Intl.DateTimeFormat().resolvedOptions().timeZone);

  // Ref for interval, so we don't create new interval each time
  const intervalRef = useRef<IntervalID>();

  const [dates, setDates] = useState({
    startDate: dateRange?.startTime,
    endDate: dateRange?.endTime
  });

  const subtractSeconds = dateRange ? (dateRange?.endTime?.getTime() - dateRange?.startTime?.getTime()) : 0;

  useEffect(() => {
    if(!dates?.endDate) return

    const machineTimeEnd = new Date(format(dates?.endDate, 'yyyy-MM-dd HH:mm:ss') + offsetString);
    const machineTimeEnd2 = utcToZonedTime(machineTimeEnd, 'UTC');

    const nowLocal = new Date(format(new Date(), 'yyyy-MM-dd HH:mm:ss') + offsetStringUser);
    const nowUTC = utcToZonedTime(nowLocal, 'UTC');

    const difference = Math.abs(nowUTC.getTime() - machineTimeEnd2.getTime()) > 3 * 60 * 1000; 


    if (difference) {
      return () => intervalRef.current && clearInterval(intervalRef.current);
    } else {
      intervalRef.current = setInterval(() => {

        const endTime = new Date().getTime()                 
        const startTime = new Date(endTime - subtractSeconds) 
        const utcStart = startTime.toISOString(); 
   
        const { utc } = getCurrentZonedTime(timeZone);

        const newRange = {
          startDate: utcToZonedTime(utcStart, timezone),
          endDate: utcToZonedTime(utc, timezone)
        };

        if (newRange?.endDate === dateRange?.endTime) return;
        setDates?.(newRange);
      }, TIMER_INTERVAL);
      return () => intervalRef.current && clearInterval(intervalRef.current);
    }

  }, [dates]);

  const settings = { className, ga, align, iconOnly };

  if (dates?.startDate === undefined || dates?.endDate === undefined) {
    console.warn('no dates')
    return <>Error</>
  }

  // generate formated dates for display, first check if they're needed
  const [start, end] = formatDateRange({
    startTime: dates?.startDate,
    endTime: dates?.endDate,
    dateFormat,
    isUSTimeZone,
    timeZone
  });

  const Dates = !iconOnly && (
    <>
      <div className="date-col pad-l">{start}</div>
      <div className="spacer-col">-</div>
      <div className="date-col">{end}</div>
    </>
  );

  return (
      <DateRangeButtonContainer onClick={() => handleClick && handleClick()} {...settings}>
        <IcoCalendar />
        {Dates}
      </DateRangeButtonContainer>
  );
};
